<template>
    <multiselect
        v-bind="$attrs"
        :multiple="false"
        :searchable="true"
        open-direction="bottom"
        :options="suggestions"
        track-by="value"
        label="value"
        :show-no-results="false"
        placeholder="Адрес установки"
        select-label=""
        deselect-label=""
        :close-on-select="true"
        :options-limit="10"
        :loading="isLoading"
        :internal-search="false"
        :clear-on-select="false"
        @search-change="asyncFind"
        @input="setValue"
        @open="onOpen"
        @close="onClose">
        <template v-slot:noOptions>
            &nbsp;
        </template>

        <template v-slot:option="scope">
            {{scope.option.value}}
        </template>

        <template slot="singleLabel" slot-scope="props">
            <span>{{ props.option.value }}</span>
        </template>

    </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
export default {
    components: {
        Multiselect
    },
    data() {
        return {
            timeout: null,
            suggestions: [],
            isLoading: false,
            suggestionsState: this.defaultOption ? [this.defaultOption] : []
        }
    },
    inheritAttrs: false,
    methods: {
        async asyncFind(query) {
            if (this.timeout) {
                clearTimeout(this.timeout)
            }

            let self = this
            this.timeout = setTimeout(async function () {
                self.isLoading = true
                let response = await axios.get('api/address-suggestions', { params: { query: query } })
                self.suggestions = response.data
                self.isLoading = false
            }, 400)
        },
        setValue(value) {
            if (value) {
                this.$emit('input', value)
            }
        },
        onClose() {
            this.suggestionsState = this.suggestions
        },
        onOpen() {
            this.suggestions = this.suggestionsState
        }
    },
    props: {
        defaultOption: {
            type: Object | Array,
            default: _ => []
        }
    }
}
</script>
